import {Component} from 'react';
import styles from './GroupDetails.scss';
import userStyles from '../User/Details/Details.scss';

export default class GroupDetails extends Component {

    render() {
        const {
            group: {
                displayName,
                description,
                users,
                documentTypes,
                priority
            }
        } = this.props;

        return (
            <div className={styles.container} data-cy="GroupDetails">
                <section>
                    <ul className={userStyles.userDetails}>
                        <li className={userStyles.detail} data-cy="GroupDetails-displayName">
                            Display Name: { displayName }
                        </li>
                        <li className={userStyles.detail} data-cy="GroupDetails-description">
                            Description: { description }
                        </li>
                        <li className={userStyles.detail} data-cy="GroupDetails-users">
                            Users: ( { users ? users.length : 0 } )
                        </li>
                        <li className={userStyles.detail} data-cy="GroupDetails-documentTypes">
                            Document Types: ( { documentTypes ? documentTypes.length : 0 } )
                        </li>
                        <li className={userStyles.detail} data-cy="GroupDetails-priority">
                            Priority: { priority }
                        </li>
                    </ul>
                </section>
            </div>
        );
    }
}
